import React from 'react'
import { IconButton } from '@mui/material'
import { CheckCircle, CheckCircleOutline } from '@mui/icons-material'
import { colors } from '@resiliatech/birdsong'

type TaskStatusCellProps = {
  isCompleted: boolean
  onStatusChange: (event: React.MouseEvent<HTMLElement>) => void | Promise<void>
}

export const TaskStatus = ({
  isCompleted,
  onStatusChange,
}: TaskStatusCellProps) => {
  const IconComponent = isCompleted ? CheckCircle : CheckCircleOutline
  return (
    <IconButton
      onClick={onStatusChange}
      size='small'
      sx={{
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '&:hover .MuiSvgIcon-root': {
          color: `${colors.primary.main}`,
        },
      }}
    >
      <IconComponent
        sx={{
          color: isCompleted
            ? `${colors.primary.main}`
            : `${colors.text.disabled}`,
          transition: 'color 0.3s',
          width: '24px',
          height: '24px',
        }}
      />
    </IconButton>
  )
}
